import Big from 'big.js';
import { Duration } from 'luxon';
import { DisplayData, TenantOrderLine } from '~/lib/model';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { PersonaType } from '~/tenants/common/TenantPersona';
import TwtJob from '~/tenants/twt/model/TwtJob';
import TwtNucleusConfig from '~/tenants/twt/performable/nucleus/TwtNucleusConfig';
import TwtNucleusJob from '~/tenants/twt/performable/nucleus/TwtNucleusJob';
import TwtNucleusHotspotsConfig from '~/tenants/twt/performable/nucleus-hotspots/TwtNucleusHotspotsConfig';

export class TwtNucleusHotspotsJob extends TwtJob<typeof TwtNucleusHotspotsConfig> {
  get performable() {
    return TwtNucleusHotspotsConfig;
  }

  get dependencies() {
    return [TwtNucleusConfig.id];
  }

  get configurable() {
    return true;
  }

  get eligible() {
    return this.orderHasNucleus;
  }

  get media() {
    return PersonaType.OFFICE;
  }

  get startWithin(): Duration | null {
    return Duration.fromObject({ days: 1 });
  }

  defaultValue(): ZodVersionedMetadata<(typeof TwtNucleusHotspotsConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      hotspots: 20,
      instructions: '',
    };
  }

  info(): DisplayData[] {
    return [
      {
        name: 'Hot Spot Information',
        value: this.metadata.instructions,
        acknowledge: true,
      },
    ];
  }

  revenueLines(): TenantOrderLine[] {
    return [
      {
        amount: new Big(TwtNucleusJob.hotspots(this.metadata.hotspots)),
        description: `Hot Spots (${this.metadata.hotspots})`,
        id: 'hotspots',
        discountable: true,
        taxable: true,
      },
    ];
  }
}
